import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ActivateAgencyAllocatorRequest,
  AgencyAllocatorRequest,
  acceptInterestFailure,
  acceptInterestRequest,
  acceptInterestSuccess,
  activateAgencyAllocatorFailure,
  activateAgencyAllocatorRequest,
  activateAgencyAllocatorSuccess,
  fetchAgencyAllocatorsFailure,
  fetchAgencyAllocatorsRequest,
  fetchAgencyAllocatorsSuccess,
  rejectInterestFailure,
  rejectInterestRequest,
  rejectInterestSuccess,
} from 'redux/slice/agency-onbording/AgencyAllocator.slice';
import { agency, agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

const fetchAgencyAllocatorsApi = async (agencyId: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_AGENCY_ALLOCATORS(agencyId)
  );
  return response.data;
};

const acceptInterestApi = async (request: AgencyAllocatorRequest) => {
  const response = await HTTPClient.PostRequest(
    agency.ACCEPT_INTEREST(),
    request
  );
  return response.data;
};

const rejectInterestApi = async (request: AgencyAllocatorRequest) => {
  const response = await HTTPClient.PostRequest(
    agency.REJECT_INTEREST(),
    request
  );
  return response.data;
};

const activateAgencyAllocatorApi = async (
  request: ActivateAgencyAllocatorRequest
) => {
  const response = await HTTPClient.PostRequest(
    agency.ACTIVATE_AGENCY(),
    request
  );
  return response.data;
};

function* fetchAgencyAllocatorsSaga(action: any): Generator<any, void, any> {
  try {
    const allocators = yield call(fetchAgencyAllocatorsApi, action.payload);
    yield put(fetchAgencyAllocatorsSuccess(allocators));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch allocators';
    yield put(fetchAgencyAllocatorsFailure(errorMessage));
  }
}

function* acceptInterestSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(acceptInterestApi, action.payload);
    yield put(acceptInterestSuccess());
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to accept interest';
    yield put(acceptInterestFailure(errorMessage));
  }
}

function* rejectInterestSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(rejectInterestApi, action.payload);
    yield put(rejectInterestSuccess());
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to reject interest';
    yield put(rejectInterestFailure(errorMessage));
  }
}

function* activateAgencyAllocatorSaga(action: any): Generator<any, void, any> {
  try {
    const resoponse = yield call(activateAgencyAllocatorApi, action.payload);
    yield put(activateAgencyAllocatorSuccess());
  } catch (error: any) {
    const errorMessage =
      error.response?.data ||
      'Failed to activate agency. Please check the provided details.';
    yield put(activateAgencyAllocatorFailure(errorMessage));
  }
}

export function* watchAgencyAllocatorSaga() {
  yield takeLatest(
    fetchAgencyAllocatorsRequest.type,
    fetchAgencyAllocatorsSaga
  );
  yield takeLatest(acceptInterestRequest.type, acceptInterestSaga);
  yield takeLatest(rejectInterestRequest.type, rejectInterestSaga);
  yield takeLatest(
    activateAgencyAllocatorRequest.type,
    activateAgencyAllocatorSaga
  );
}
